import { createMuiTheme, Theme } from '@material-ui/core/styles';
import typography from './Typography';
import { shadows } from './Shadows';
import { baselightTheme } from './DefaultColors';
import { LightThemeColors } from './LightThemeColors';
import { buildOverrides, componentProps } from './Components';

export interface BuildFleetThemeConfig {
  theme?: string;
  direction?: 'ltr' | 'rtl';
}

export const BuildTheme = (config: BuildFleetThemeConfig = {}): Theme => {
  const themeName = config.theme || 'CYAN_THEME';
  const selected =
    LightThemeColors.find((t) => t.name === themeName) ||
    LightThemeColors.find((t) => t.name === 'CYAN_THEME');

  const palette: any = {
    ...baselightTheme.palette,
    primary: { ...baselightTheme.palette.primary, ...(selected ? selected.palette.primary : {}) },
    secondary: {
      ...baselightTheme.palette.secondary,
      ...(selected ? selected.palette.secondary : {})
    }
  };

  const base = {
    direction: config.direction || 'ltr',
    palette,
    typography,
    shadows: shadows as any,
    shape: { borderRadius: 7 }
  };

  let theme = createMuiTheme(base as any);
  theme = createMuiTheme({
    ...(base as any),
    overrides: buildOverrides(theme),
    props: componentProps
  });

  return theme;
};

export default BuildTheme;
